<template>
  <div class="icon-block">
    <div class="title">選擇卡片樣式</div>
    <div class="icons">
      <div
        v-for="(card, idx) in cardData"
        :key="idx"
        class="icon"
        :class="{ active: selectedIndex === idx }"
        @click="selectIcon(idx)"
      >
        <div v-if="card.limited" class="limited">限定</div>
        <div class="image-border">
          <div class="image">
            <img :src="card.icon" />
          </div>
        </div>
        <div class="theme">{{ card.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'IconBlock',
  props: {
    cardData: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['selected-index'],
  setup(props, { emit }) {
    const selectedIndex = ref(0);
    const selectIcon = (index) => {
      selectedIndex.value = index;
      emit('selected-index', index);
    };

    return {
      selectIcon,
      selectedIndex,
    };
  },
};
</script>

<style lang="scss" scoped>
.icon-block {
  .title {
    text-align: left;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    margin-bottom: 16px;
  }
  .icons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 112px;
    .icon {
      position: relative;
      padding-bottom: 20px;

      .limited {
        min-width: 36px;
        height: 20px;
        font-size: 12px;
        line-height: 20px;
        color: #007bca;
        background: #ffffff;
        border: 1px solid #007bca;
        box-sizing: border-box;
        border-radius: 10px;
        padding: 0px 6px;
        position: absolute;
        top: -10px;
        left: calc(50% - 19px);
        z-index: 5;
      }
      .image-border {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: none;
        padding: 2px;
        opacity: 0.5;
        position: relative;
        z-index: 0;
        .image {
          width: 100%;
          height: 100%;
          border-radius: 999rem;
          overflow: hidden;
          background-color: #333333;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .theme {
        font-size: 13px;
        line-height: 20px;
        color: #c2c2c2;
      }

      &.active {
        .limited {
          background: linear-gradient(90deg, #3bc3af 0%, #5eccf0 100%);
          border: 1px solid transparent;
          color: #ffffff;
        }
        .image-border {
          opacity: 1;
          background: linear-gradient(90deg, #3bc3af 0%, #5eccf0 100%);
          box-shadow: 0px 0px 40px 5px rgba(50, 215, 215, 0.4);
        }
        .theme {
          color: #666666;
        }
      }
    }
  }
}

@media (min-width: 450px) {
  .icon-block {
    .icons {
      .icon {
        .image-border {
          width: calc(80vw / 4);
          height: calc(80vw / 4);
          padding: 4px;
        }
      }
    }
  }
}
</style>
